export function swiperFactory(PALETTE) {
    return {
        Swiper: {
            backwardNavigation: {
                button: {
                    buttonIcon: {
                        src: 'arrow-left',
                    },
                    button: {
                        style: {
                            base: {
                                left: 8,
                            },
                        },
                    },
                },
            },
            forwardNavigation: {
                button: {
                    buttonIcon: {
                        src: 'arrow-right',
                    },
                    button: {
                        style: {
                            base: {
                                right: 8,
                            },
                        },
                    },
                },
            },
        },
        SwiperNavigationButton: {
            container: {
                style: {
                    width: 'initial',
                },
            },
            button: {
                buttonIcon: {
                    style: {
                        minWidth: 10,
                        width: 10,
                        minHeight: 10,
                        height: 10,
                        fill: PALETTE.SWIPER_NAVIGATION.PIVOT_SCROLL_BUTTON_ICON_COLOR,
                    },
                },
                button: {
                    style: {
                        base: {
                            // we should think about separate token for this type of buttons
                            backgroundColor: PALETTE.SWIPER_NAVIGATION.PIVOT_SCROLL_BUTTON_BG,
                            height: 32,
                            width: 32,
                            minHeight: 32,
                            minWidth: 32,
                            borderRadius: '50%',
                            top: 'calc(50% - 16px)',
                        },
                    },
                },
            },
        },
    };
}
